import { createFeature } from '@ngrx/store';

import { manageSurveyReferenceReducer } from './manage-survey-reference.reducer';

export const manageSurveyReferenceFeatureKey = 'manageSurveyReference';

export const manageSurveyReferenceFeature = createFeature({
  name: manageSurveyReferenceFeatureKey,
  reducer: manageSurveyReferenceReducer,
});
